import { render, staticRenderFns } from "./ServiceTypeDetailView.vue?vue&type=template&id=9f3c2bd4&scoped=true"
import script from "./ServiceTypeDetailView.vue?vue&type=script&lang=js"
export * from "./ServiceTypeDetailView.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeDetailView.vue?vue&type=style&index=0&id=9f3c2bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3c2bd4",
  null
  
)

export default component.exports